export const chatToken = () => {
    // var jwt = require('jsonwebtoken');
    // return jwt.sign({ foo: 'bar' }, process.env.REACT_APP_JWT_SECRET || "");
    return authToken()
}

export const authToken = () => {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.data && user.data.auth && user.data.auth.AuthToken) {
        return user.data.auth.AuthToken;
    } else {
        return "NOT AUTHENTICATED";
    }
}
